import "./App.css";
import Home from "./pages/Home";
import Signup from "./pages/Signup";
import NavBar from "./components/NavBar";
import Footer from "./components/Footer";
import { Switch, Route } from "react-router-dom";
import Notifications from "react-notify-toast";
import { useState } from "react";
import LoadingOverlay from "react-loading-overlay";

function App() {
    const [isLoading, setIsLoading] = useState(false);

    const routes = [
        {
            path: "/",
            component: <Home isLoading={isLoading} setLoading={setIsLoading} />,
        },
        {
            path: "/signup",
            component: (
                <Signup isLoading={isLoading} setLoading={setIsLoading} />
            ),
        },
    ];

    return (
        <LoadingOverlay
            active={isLoading}
            spinner
            text="Loading ..."
        >
            <div className="bg-gray-50">
                <Notifications />
                <NavBar />
                <Switch>
                    {routes.map((route, i) => {
                        return (
                            <Route exact path={route.path} key={i}>
                                {route.component}
                            </Route>
                        );
                    })}
                </Switch>
                <Footer />
            </div>
        </LoadingOverlay>
    );
}

export default App;
